import ScalarSidebarGroupToggleButton_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarGroupToggleButton.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSidebar/ScalarSidebarGroupToggleButton.vue
var ScalarSidebarGroupToggleButton_default = ScalarSidebarGroupToggleButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarGroupToggleButton_default as default };

//# sourceMappingURL=ScalarSidebarGroupToggleButton.vue.js.map